<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Add new festival provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('MESSAGES.Festival provider image')"
            @selectImage="selectImage"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival provider arabic name')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival provider english name')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobileNumber')"
            v-model.trim="data.mobile"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Commission percentage from the center')"
            v-model.trim="data.commission"
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("MESSAGES.centerOwnerData") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.centerOwnerName')"
            v-model.trim="data.owner_name"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="owner_image"
            :placeholder="$t('PLACEHOLDERS.centerOwnerImage')"
            @selectImage="selectOwnerImage"
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("PLACEHOLDERS.contacts") }}</h4>
          </div>
          <div class="col-12">
            <label class="form-label mb-2">{{
              $t("PLACEHOLDERS.contactPhoneNumbers")
            }}</label>
          </div>
          <div class="col-12">
            <div class="add_another d-inline-flex mb-3" @click="addPhoneRow">
              <i class="fas fa-plus"></i>
            </div>
          </div>
          <div
            class="col-lg-6 col-12"
            v-for="(item, index) in phone_numbers"
            :key="'phone-' + index"
          >
            <div class="item d-flex align-items-center">
              <base-input
                class="w-100"
                type="tel"
                :placeholder="$t('PLACEHOLDERS.contactPhoneNumber')"
                v-model.trim="item.phone"
              />
              <div class="all_actions" v-if="phone_numbers.length > 1">
                <span class="add_another" @click="removePhoneRow(index)">
                  <i class="fas fa-minus"></i>
                </span>
              </div>
            </div>
          </div>
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.whatsapp_number"
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("MESSAGES.socialMediaLinks") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.social_media_links.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.social_media_links.instagram"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snapchat')"
            v-model.trim="data.social_media_links.snapchat"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.twitter_link')"
            v-model.trim="data.social_media_links.x"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok')"
            v-model.trim="data.social_media_links.tiktok"
          />
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseMultiImageUploadInput from "../../../components/formInputs/BaseMultiImageUploadInput.vue";
import BaseNamePreviewFileUploadInput from "../../../components/formInputs/BaseNamePreviewFileUploadInput.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import { validateFestivalProviderFields } from "@/utils/festivalProviderValidation";

export default {
  name: "CreateProviders",

  components: {
    ChangableMapComponent,
    BaseMultiImageUploadInput,
    BaseNamePreviewFileUploadInput,
  },

  data() {
    return {
      isWaitingRequest: false,
      sections: [],
      section_id: null,
      store_waiting: null,
      file: null,
      fileType: "",
      phone_numbers: [{ phone: "" }],
      additionalImages: [],
      data: {
        media: {
          path: null,
          file: null,
        },
        owner_media: {
          path: null,
          file: null,
        },
        additionalImages: [],
        owner_name: null,
        mobile: null,
        commission: 0,
        whatsapp_number: null,
        nameAr: null,
        social_media_links: {
          facebook: null,
          instagram: null,
          tiktok: null,
          x: null,
          snapchat: null,
        },
        nameEn: null,
        descProd: null,
        lat: 24.7136,
        lng: 46.6753,
        descProdEn: null,
        dropdownOptions: {},
        active: true,
        featured_tag: true,
        email: null,
        password: null,
        passwordConfirmation: null,
      },
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  methods: {
    setLocation(event, index) {
      this.data.lat = event.latLng.lat();
      this.data.lng = event.latLng.lng();
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.data.imgUrls, index);
    },
    onFileSelectField(files) {
      this.data.additionalImages = files;
    },
    onFileRemoveField(index) {
      this.$delete(this.data.imgUrls, index);
    },
    selectImage(selectedImage) {
      this.data.media = selectedImage;
    },

    selectOwnerImage(selectedImage) {
      this.data.owner_media = selectedImage;
    },

    addPhoneRow() {
      this.phone_numbers.push({ phone: "" });
    },

    removePhoneRow(index) {
      this.phone_numbers.splice(index, 1);
    },

    showFields(storeId) {
      if (storeId && storeId.fields) {
        this.data.section_id = storeId;
      }
    },

    // async fetchDropdownOptions(fieldId) {
    //   try {
    //     const res = await this.$axios.get(`/dropdown-options/${fieldId}`);
    //     console.log("res", res);
    //     this.dropdownOptions[fieldId] = res.data.options;
    //   } catch (error) {
    //     console.error("Error fetching dropdown options", error);
    //   }
    // },

    validateFormInputs() {
      const validationError = validateFestivalProviderFields(
        this.data.mobile,
        this.data.commission,
        this.data.owner_name,
        this.data.password,
        this.data.passwordConfirmation,
        this.$t.bind(this),
        { passwordRequired: true }
      );

      if (validationError) {
        this.$message.error(validationError);
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("owner_name", this.data.owner_name ?? "");
      REQUEST_DATA.append("name[ar]", this.data.nameAr ?? "");
      REQUEST_DATA.append("name[en]", this.data.nameEn ?? "");
      REQUEST_DATA.append("description[ar]", this.data.descProd ?? "");
      REQUEST_DATA.append("description[en]", this.data.descProdEn ?? "");
      if (this.data.media.file)
        REQUEST_DATA.append("logo", this.data.media.file);
      if (this.data.owner_media.file)
        REQUEST_DATA.append("owner_image", this.data.owner_media.file);

      REQUEST_DATA.append("email", this.data.email ?? "");
      REQUEST_DATA.append("country_code", "966");
      REQUEST_DATA.append("mobile", this.data.mobile ?? "");
      REQUEST_DATA.append("password", this.data.password ?? "");
      REQUEST_DATA.append(
        "password_confirmation",
        this.data.passwordConfirmation ?? ""
      );

      REQUEST_DATA.append("commission", this.data.commission ?? 0);

      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      this.phone_numbers.forEach((element, index) => {
        if (String(element.phone ?? "").trim()) {
          REQUEST_DATA.append(`phone_numbers[${index}]`, element.phone);
        }
      });

      REQUEST_DATA.append(
        "whatsapp_number",
        this.data.whatsapp_number ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[facebook]",
        this.data.social_media_links.facebook ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[instagram]",
        this.data.social_media_links.instagram ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[tiktok]",
        this.data.social_media_links.tiktok ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[snapchat]",
        this.data.social_media_links.snapchat ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[x]",
        this.data.social_media_links.x ?? ""
      );

      // Send the request with the FormData
      try {
        await this.$axios({
          method: "POST",
          url: "festival-providers",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/festival-providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {},
};
</script>
